<!-- Card for non-HTST sensors -->
@if (!isHtstSensor()) {
  <app-card [class.desktop]="!isMobile()" [class.mobile]="isMobile()">
    <nz-list nzSize="small" class="addInfo-list">
      @if (sensor()) {
        @for (group of InstallationData(); let i = $index; track i) {
          <nz-list-item class="regular addInfo-list-item">
            <span class="body-bold-cap addInfo-label">{{ group.header }}</span>
            @for (item of group.items; let j = $index; track j) {
              <span>{{ item.text }}</span>
            }
          </nz-list-item>
        }
      } @else {
        <app-spinner [black]="true"></app-spinner>
      }
    </nz-list>
  </app-card>
}

<!-- Card for HTST sensors -->
@if (isHtstSensor()) {
  <app-card [class.desktop]="!isMobile()" [class.mobile]="isMobile()">
    <div class="htst-sensor-section">
      <div class="content-flex">
        <div class="body-bold-cap">
          {{ i18n.langString("sensor_installation_date") }}
        </div>
        <span class="date">{{ installationDate() }}</span>
      </div>

      <app-htst-info-data
        [htstInfo]="inletHtstInfo()"
        [sensorType]="i18n.langString('Inlet_Sensor')"
      >
      </app-htst-info-data>

      <app-htst-info-data
        [htstInfo]="outletHtstInfo()"
        [sensorType]="i18n.langString('Outlet_Sensor')"
      >
      </app-htst-info-data>
    </div>
  </app-card>
}
